<script setup lang="ts">
interface Props {
	done: boolean;
}

defineProps<Props>();
</script>

<template>
	<div
		class="flex size-4 shrink-0 items-center justify-center rounded-full border sm:size-3"
		:class="done ? 'border-primary bg-primary' : 'border-accented bg-muted'"
	>
		<DIcon
			v-if="done"
			name="lucide:check"
			class="size-3 text-inverted sm:size-2.5"
		/>
	</div>
</template>
